import { render, staticRenderFns } from "./SliderFirst.vue?vue&type=template&id=7c8136b2&scoped=true&"
import script from "./SliderFirst.vue?vue&type=script&lang=js&"
export * from "./SliderFirst.vue?vue&type=script&lang=js&"
import style0 from "./SliderFirst.vue?vue&type=style&index=0&id=7c8136b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8136b2",
  null
  
)

export default component.exports